export const ExportConstants = {
  EXCEL_CELL_FONT_WITH_ACCENTS: { name: 'Arial', size: 11 }, // Arial font that supports accents
} as const;
